<template>

  <div>

    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{sidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings" id="presentationTaskDetails">
      <div class="pl-6 pr-6">
        <div ref="presentationType">
          <ul class="flex flex-wrap items-center justify-center pb-4">
            <li>
              <vs-radio v-model="presentationType" vs-value=1 class="pr-10">Other</vs-radio>
            </li>
            <li>
              <vs-radio v-model="presentationType" vs-value=2>iSpring</vs-radio>
            </li>
          </ul>
        </div>

        <div v-if="this.$siteTypeId() != 1">
          <div>
            <label>Task Classification</label>
            <v-select class="mb-3" ref="taskClassificationTypeDropdown" placeholder="Search / Select Task Classification"  :options="taskClassificationTypeList" v-model="taskClassificationTypeText"></v-select>
          </div>
        </div>

        <div>
          <label ref="nameLabel">Name</label>
          <vs-input autocomplete="off" class="w-full mb-3" v-model="formData.name"/>
        </div>
        <div v-show="presentationType == 1">
          <label ref="urlLabel">Presentation Url</label>
          <vs-input autocomplete="off" class="w-full mb-3" v-model="formData.presentationUrl"/>
          <div class="self-center ml-3">
            <feather-icon id="info-icon" @click="linkHelpPopupActive = true" class="mt-2" icon="InfoIcon" svg-classes="stroke-current"></feather-icon>
          </div>
        </div>

        <div v-show="presentationType == 2">
          <label ref="sceneLabel">iSpring Presentation</label>
          <vs-select placeholder="Search / Select iSpring Presentation" class="w-full mb-3" vs-multiple autocomplete v-model="formData.iSpringPresentationId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in presentations" />
          </vs-select>
        </div>

        <div style="display: inline-grid;">
          <label>Task Number</label>
          <vs-input-number class="numberinput" onClick="this.select();" v-model="formData.number" min="0" />
        </div>
        <div v-if="this.$siteTypeId() != 1">
          <vs-divider>Outcomes</vs-divider>

            <div>
              <label>Assessment Criteria</label>
              <v-select class="mb-2" ref="assessmentCriteriaDropdown" placeholder="Search / Select Assessment Criteria"  :options="assessmentCriteriaList" v-model="assessmentCriteriaText"></v-select>
            </div>
            <div>
              <label>Essential Embedded Knowledge</label>
              <v-select class="mb-2" ref="eEKDropdown" placeholder="Search / Select EEK"  :options="eekList" v-model="essentialEmbeddedKnowledgeText"></v-select>
            </div>
            <div>
              <label>Unit Standard</label>
              <v-select class="mb-2" ref="unitStandardDropdown" placeholder="Search / Select Unit Standard"  :options="unitStandardList" v-model="unitStandardText"></v-select>
            </div>
              <div>
                <label>Spesific Outcome</label>
                <v-select class="mb-2" ref="spesificOutcomeDropdown" placeholder="Search / Select Spesific Outcome"  :options="spesificOutcomeList" v-model="spesificOutcomeText"></v-select>
              </div>
          </div>
        <vs-divider v-if="!styleB">Go To</vs-divider>

        <div v-if="!styleB">
          <div class="pt-1">
            <vs-radio v-model="gotoRadio" vs-value="existingTask">Existing Task</vs-radio>
          </div>
          <div class="pt-2">
            <vs-radio v-model="gotoRadio" vs-value="newTask">Create New Task</vs-radio>
          </div>
          <div class="pt-2">
            <vs-radio v-model="gotoRadio" vs-value="none">None</vs-radio>
          </div>
        </div>


        <div class="pt-4" v-show="gotoRadio == 'existingTask' ">
          <label>Go To</label>
          <vs-select placeholder="Search / Select Go To task" class="w-full pb-3" vs-multiple autocomplete v-model="formData.goTo">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in gotoList" />
          </vs-select>
          <div>
            <div style="margin-bottom: 8px; margin-top: 2px;">
              <vs-checkbox color="success" v-model="formData.useCoins">Coins</vs-checkbox>
            </div>
            <div v-if="formData.useCoins && gotoRadio == 'existingTask'">
              <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                <vs-switch color="success" v-model="formData.isCoinsRecurring">
                  <span slot="on">Recurring</span>
                  <span slot="off">Once Only</span>
                </vs-switch>
                <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addCoins">
                  <span slot="on">Add</span>
                  <span slot="off">Deduct</span>
                </vs-switch>
              </div>
              <label style="margin-left: 5px;">Coin Value</label>
              <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.coinValue" />
              <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
            </div>
          </div>
        </div>

        <div class="pt-4" v-show="gotoRadio == 'newTask'">
          <label>New Task Type</label>
          <vs-select placeholder="Search / Select a Task Type" class="w-full pb-3" vs-multiple autocomplete v-model="formData.taskTypeId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in taskTypeList" />
          </vs-select>
          <div>
            <div style="margin-bottom: 8px; margin-top: 2px;">
              <vs-checkbox color="success" v-model="formData.useCoins">Coins</vs-checkbox>
            </div>
            <div v-if="formData.useCoins && gotoRadio == 'newTask'">
              <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                <vs-switch color="success" v-model="formData.isCoinsRecurring">
                  <span slot="on">Recurring</span>
                  <span slot="off">Once Only</span>
                </vs-switch>
                <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addCoins">
                  <span slot="on">Add</span>
                  <span slot="off">Deduct</span>
                </vs-switch>
              </div>
              <label style="margin-left: 5px;">Coin Value</label>
              <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.coinValue" />
              <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
            </div>
          </div>
        </div>

      </div>
    </VuePerfectScrollbar>

    

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="addEditPresentation" :disabled="isDisabled" ref="addupdateButton">{{buttoncaption}}</vs-button>
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" @click="deleteApproach" v-show="formData.id" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
    <b-modal
      id="info-popup"
      hide-backdrop
      hide-footer
      scrollable
      content-class="shadow"
      title="Information"
      v-model="linkHelpPopupActive"
      size="lg"
    >
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <vs-tabs v-model="activeTab" alignment="fixed">
            <vs-tab label="Google Slides">
              <div class="tab-text">
                <div class="vx-row mb-3 mt-2">
                  <div class="vx-col w-full text-center">
                    <code style="font-size:12pt">File → Publish to the web → Embed → Publish</code>
                  </div>
                </div>
                <div class="vx-row overflow-auto">
                  <div class="vx-col w-full text-center overflow-auto">
                    <img src="https://lateralscaffolding.blob.core.windows.net/resources/Google Slides publish.png" alt="Google Slides">
                  </div>
                </div>
                <div class="vx-row mt-2">
                  <div class="vx-col w-full text-center">
                    <span><small>Please Note: only copy the highlighted text</small></span>
                  </div>
                </div>
              </div>
            </vs-tab>
            <vs-tab label="Office 365 PowerPoint">
              <div class="tab-text">
                <div class="vx-row mb-3">
                  <div class="vx-col w-full text-center">
                    <code style="font-size:12pt">File → Share → Embed → Generate</code>
                  </div>
                </div>
                <div class="vx-row overflow-auto">
                  <div class="vx-col w-full text-center">
                    <img src="https://lateralscaffolding.blob.core.windows.net/resources/Office 365 publish.png" alt="Office 365 PowerPoint">
                  </div>
                </div>
                <div class="vx-row mt-2">
                  <div class="vx-col w-full text-center">
                    <span><small>Please Note: only copy the highlighted text</small></span>
                  </div>
                </div>
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
    </b-modal>
  </div>

  
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from 'vue-select';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    courseId: {
      type: String,
      required: true
    },
    moduleId: {
      type: String,
      required: true
    },
    nodeSelected: {
      type: Object,
      required: false
    },
    taskClassificationTypes: {
      type: Array,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    },
    gotoList: {
      type: Array,
      required: false
    },
    sourceTaskId: {
      type: Number,
      required: false
    },
    taskTypeList: {
      type: Array,
      required: false
    },
    taskGroupId:{
      type: Number,
      required: false
    },
    styleB:{
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      backgroundLoading:'#fff',
      formData: {
        id: 0,
        goTo: 0,
        name: "",
        moduleId: "",
        taskTypeId: 0,
        sourceTaskId: 0,
        presentationUrl: "",
        iSpringPresentationId: "",
        hasLogs: false,
        useCoins: false,
        isCoinsRecurring: false,
        addCoins: true,
        coinValue: "",
        number: 0,
        spesificOutcomeId: null,
        unitStandardId: null,
        assessmentCriteriaId: null,
        essentialEmbeddedKnowledgeId: null,
        taskClassificationTypeId: null,
        taskGroupId:null,
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      presentations: [],
      gotoRadio: "",
      presentationType: 1,
      spesificOutcomeDropdown: null,
      unitStandardDropdown: null,
      assessmentCriteriaDropdown: null,
      eEKDropdown: null,
      taskClassificationTypeDropdown: null,
      spesificOutcomeList: [],
      unitStandardList: [],
      assessmentCriteriaList: [],
      eekList: [],
      taskClassificationTypeList: [],
      spesificOutcomeText: null,
      unitStandardText: null,
      assessmentCriteriaText: null,
      essentialEmbeddedKnowledgeText: null,
      taskClassificationTypeText: null,
      linkHelpPopupActive: false,
      activeTab: 0
    };
  },
  computed: {
    isDisabled: function() {
      return !(this.formData.presentationUrl || this.formData.iSpringPresentationId);
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
  },
  watch: {
    isSidebarActive: function(val) {
      if(val){
        var self = this;

        var goToDisplayValue = 0;
        if(self.nodeSelected.presentationTask)
          goToDisplayValue = self.nodeSelected.presentationTask.goTo;
        else
          goToDisplayValue = 0;

        var onSuccess = response => { self.presentations = response.data; };

        self.$ajaxGet(self, "ispringpresentation/getselectlist", onSuccess);

        self.formData.moduleId = self.moduleId;
        self.taskClassificationTypeList = self.taskClassificationTypes;
        self.getEEK();
        self.getUnitStandard();
        self.getSpesificOutcome();
        self.GetAssessmentCriteria();
        
        if(self.nodeSelected.id){
          self.formData.id = self.nodeSelected.id;
          self.formData.name = self.nodeSelected.name;
          self.formData.sourceTaskId = self.sourceTaskId;
          self.formData.hasLogs = self.nodeSelected.presentationTask.hasLogs;
          self.formData.useCoins = self.nodeSelected.presentationTask.coinValue ? true : false;
          self.formData.addCoins = self.nodeSelected.presentationTask.coinValue > 0 ? true : false;
          self.formData.isCoinsRecurring = self.nodeSelected.presentationTask.isCoinsRecurring;
          self.formData.coinValue = self.nodeSelected.presentationTask.coinValue > 0 ? self.nodeSelected.presentationTask.coinValue : (self.nodeSelected.presentationTask.coinValue * -1);
          self.taskClassificationTypeText = self.taskClassificationTypeList.filter(function(item){return item.value == self.nodeSelected.taskClassificationTypeId})[0];

          if (self.nodeSelected.number)
            self.formData.number = self.nodeSelected.number;
          else
            self.formData.number = 0;

          if(self.nodeSelected.presentationTask.iSpringPresentationId) {
            self.presentationType = 2;
            self.formData.iSpringPresentationId = self.nodeSelected.presentationTask.iSpringPresentationId;
            self.formData.presentationUrl = "";
          }
          else if (self.nodeSelected.presentationTask.url) {
            self.presentationType = 1;
            self.formData.presentationUrl = self.nodeSelected.presentationTask.url;
            self.formData.iSpringPresentationId = "";
          }
          
          if(goToDisplayValue != 0)
            self.formData.goTo = self.gotoList.filter(function(item){ return item.text.split(" ")[0] == goToDisplayValue; })[0].value;

          if(self.formData.goTo){
            self.gotoRadio = "existingTask";
          } else {
            self.gotoRadio = "none";
          }

        }else{
          this.initValues(self.sourceTaskId || 0);
          this.presentationType = 1;
        }
      }else {
        var scrollOptions = {
          container: '#presentationTaskDetails',
          easing: 'ease-in',
          offset: -10000,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(this.$refs["presentationType"], 0, scrollOptions);
      }
    }
  },
  methods: {
    getEEK(){
      var self =this;

      var onSuccess = function (response) {
        self.eekList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.essentialEmbeddedKnowledgeText = self.eekList.filter(function(item){return item.value == self.nodeSelected.essentialEmbeddedKnowledgeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/EEK?courseId=" + self.courseId, onSuccess);
    },
    getUnitStandard(){
      var self =this;

      var onSuccess = function (response) {
        self.unitStandardList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.unitStandardText = self.unitStandardList.filter(function(item){return item.value == self.nodeSelected.unitStandardId})[0];
        }
      }

      self.$ajaxGet(self, "Course/UnitStandard?courseId=" + self.courseId, onSuccess);
    },
    getSpesificOutcome(){
      var self =this;

      var onSuccess = function (response) {
        self.spesificOutcomeList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.spesificOutcomeText = self.spesificOutcomeList.filter(function(item){return item.value == self.nodeSelected.spesificOutcomeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/SpecificOutcome?courseId=" + self.courseId, onSuccess);
    },
    GetAssessmentCriteria(){
      var self =this;

      var onSuccess = function (response) {
        self.assessmentCriteriaList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.assessmentCriteriaText = self.assessmentCriteriaList.filter(function(item){return item.value == self.nodeSelected.assessmentCriteriaId})[0];
        }
      }

      self.$ajaxGet(self, "Course/AssesmentCriteria?courseId=" + self.courseId, onSuccess);
    },
    initValues(val) {
      this.presentationType = 1;
      this.gotoRadio = "none";
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.sourceTaskId = 0;
      this.formData.useCoins = false;
      this.formData.addCoins = true;
      this.formData.isCoinsRecurring = false;
      this.formData.coinValue = "";
      this.formData.number = 0;
      this.spesificOutcomeText= null;
      this.unitStandardText = null;
      this.assessmentCriteriaText = null;
      this.essentialEmbeddedKnowledgeText = null;
      this.taskClassificationTypeText = null;
      if(val){
        this.formData.sourceTaskId = val;
      }
      
      this.formData.presentationUrl = "";
      this.formData.iSpringPresentationId = "";
      this.formData.goTo = "";
      this.formData.taskTypeId = 0;
      this.errors.clear();
    },
    saveData(val,taskTypeId){
      this.$emit('saveData',val,taskTypeId);
      this.$vs.loading.close(this.$refs.addupdateButton.$el);
      this.initValues(val);
    },
    addEditPresentation() {

      if (self.styleB && !(self.spesificOutcomeText && self.spesificOutcomeText.value)) {
        self.$vs.notify({
          title:'Warning',
          color: "warning",
          text: "Please select a Specific Outcome for the task",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-slash',
          time: 5000
        });
        return;
      }
      
      this.$validator.validateAll().then(result => {
        var self = this;
        if (result) {
          self.showLoadingOnButton();

          if(self.presentationType == 1)
            self.formData.iSpringPresentationId = null;
          else
            self.formData.presentationUrl = null;
          
          var onSuccess = response => {
            if(self.gotoRadio == "newTask"){
              self.saveData( response.data, self.formData.taskTypeId );
            }
            else {
              self.saveData(0, self.formData.taskTypeId);
              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Task Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            }
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.addupdateButton.$el);
          };

          if(self.gotoRadio == "none" || self.gotoRadio == "newTask"){
            self.formData.goTo = "0";
          } else if (self.gotoRadio == "existingTask"){
          }
          self.formData.taskClassificationTypeId = self.taskClassificationTypeText ? self.taskClassificationTypeText.value: null;

          self.formData.unitStandardId = self.unitStandardText ? self.unitStandardText.value: null

          self.formData.essentialEmbeddedKnowledgeId = self.essentialEmbeddedKnowledgeText ? self.essentialEmbeddedKnowledgeText.value: null;

          self.formData.assessmentCriteriaId = self.assessmentCriteriaText ?  self.assessmentCriteriaText.value: null;

          self.formData.spesificOutcomeId = self.spesificOutcomeText ?  self.spesificOutcomeText.value: null;

          self.formData.taskGroupId = self.taskGroupId ?  self.taskGroupId : null;
          self.$ajaxPost(self, "presentationtask/addeditpresentationtask", self.formData, onSuccess, onFinally);
        }
      });
      var scrollOptions = {
        container: '#presentationTaskDetails',
        easing: 'ease-in',
        offset: -1000,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      var cancelScroll = this.$scrollTo(this.$refs["presentationType"], 500, scrollOptions);
    },
    deleteTask() {
      var self = this;
      self.showLoadingOnDeleteButton();
      if(self.formData.hasLogs)
        self.showLoadingOnCytoscape();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Task Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
        self.$vs.loading.close(self.$parent.$el);
      }

      self.$ajaxDelete(self, "presentationtask/deletepresentationtask/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnCytoscape(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    deleteApproach() {
      if(this.formData.hasLogs)
        this.openConfirm();
      else
        this.deleteTask();
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Attention`,
        text: 'Are you sure you want to delete the selected presentation task?',
        accept: this.deleteTask,
        acceptText: "Yes, delete",
        cancelText: "No, cancel"
      })
    },
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  }
};
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background

  {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
    .img-upload

  {
    margin-top: 2rem;
    .con-img-upload

  {
    padding: 0;
  }

  .con-input-upload {
    width: 100%;
    margin: 0;
  }

  }
  }
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }

[id^=info-popup] {
  z-index: 53000 !important;
  .modal-body {
    background-color: rgba(var(--vs-prependslotbg), 1) !important;
  }

  .vs-tabs-primary .con-ul-tabs .line-vs-tabs {
    background: linear-gradient(30deg, rgba(255,255,255,1), rgba(255,255,255,.5)) !important;
    box-shadow: 0 0 8px 0 rgba(255,255,255,.4)!important;
    background: linear-gradient(30deg, rgba(var(--vs-secondary),1), rgba(var(--vs-secondary),.5)) !important;
  }
  .vs-tabs-primary .con-ul-tabs .activeChild button, .vs-tabs-primary .con-ul-tabs button:not(:disabled):hover {
    color: rgba(255,255,255,1)!important;
  }
}
</style>
